import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { StarRatingsAdvanced } from '@rx-applications/shared/utils';

@Component({
  selector: 'rx-star-rating-advanced',
  templateUrl: './star-rating-advanced.component.html',
  styleUrls: ['./star-rating-advanced.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRatingAdvancedComponent implements OnInit, OnDestroy {
  private _items: StarRatingsAdvanced[] = [];
  private ratingChanged = new Subject<void>();
  private subscription = new Subscription();

  get items() {
    return this._items;
  }

  /**
   * Disables checkboxes
   */
  @Input() disabled = null;

  /**
   * Star categories
   */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  @Input() set items(value: StarRatingsAdvanced[]) {
    this._items = JSON.parse(JSON.stringify(value)).sort((a, b) => (a.numberOfStars > b.numberOfStars ? -1 : 1));
  }

  /**
   * Width of container. By default 100%. Accepts values with units: "200px", "100%", "5rem" etc.
   */
  @Input() width = '100%';

  /**
   * Delay between selections in ms
   */
  @Input() delayBetweenSelections = 0;

  /**
   * Text for the checkbox without rating
   */
  @Input() notRatedText = 'Not rated';

  /**
   * On category selection
   */
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onRatingChanged = new EventEmitter<StarRatingsAdvanced[]>();

  ngOnInit() {
    this.subscription.add(
      this.ratingChanged.pipe(debounceTime(this.delayBetweenSelections)).subscribe(() => this.onRatingChange()),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * On category selection
   */
  onRatingChangeRequested() {
    this.ratingChanged.next();
  }

  private onRatingChange() {
    this.onRatingChanged.emit(this.items);
  }
}
